import { render, staticRenderFns } from "./AppointmentInvitationPreview.vue?vue&type=template&id=c3d3b456&scoped=true&"
import script from "./AppointmentInvitationPreview.vue?vue&type=script&lang=js&"
export * from "./AppointmentInvitationPreview.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentInvitationPreview.vue?vue&type=style&index=0&id=c3d3b456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d3b456",
  null
  
)

export default component.exports